import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Box, Button, useMediaQuery, useTheme, Typography, } from "@mui/material";
import { colCenter } from "../../style/style";
import { SwitchLanguage } from "@ui/components/language";
import { Message2, MessageQuestion } from "iconsax-react";
import { useEffect, useState } from "react";
import { useAppSelector } from "@application/store/useStore";
import { useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { FAQs } from "@ui/containers/event/faqs";
import { ContactUs } from "@ui/containers/event/contact-us";
export const EventHeader = ({ handleDrawer, handleMenu, }) => {
    const navigate = useNavigate();
    const theme = useTheme();
    const { t } = useTranslation();
    const isSmallScreen = useMediaQuery("(max-width:901px)");
    const isBelow390 = useMediaQuery("(max-width:391px)");
    const isBelow1024 = useMediaQuery("(max-width:1025px)");
    const isBelow576 = useMediaQuery(theme.breakpoints.down(577));
    const isBelow450 = useMediaQuery(theme.breakpoints.down(451));
    const { linkVerification } = useAppSelector((state) => state.event);
    return (_jsx(_Fragment, { children: _jsxs(Box, { sx: {
                boxShadow: "0px 4px 0px 0px #2423470A",
                position: "sticky",
                background: "#FFFFFF",
                borderRadius: { xs: 2, md: 3 },
                py: 2,
                px: isBelow390 ? 1 : 2,
                zIndex: 20,
                height: isBelow1024 ? 72 : 80,
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                [theme.breakpoints.up(1024)]: {
                    mx: 6,
                    top: 24,
                    width: "calc(100% - 96px)", // Adjusted width for larger screens
                },
                [theme.breakpoints.down(1025)]: {
                    mx: 2.5,
                    top: 16,
                    width: "calc(100% - 40px)", // Adjusted width for larger screens
                },
                [theme.breakpoints.down(391)]: {
                    mx: 0,
                    top: 0,
                    width: "100%", // Adjusted width for larger screens
                    borderTopRightRadius: 0,
                    borderTopLeftRadius: 0,
                },
            }, children: [linkVerification?.data?.user?.companyName !== "VDK Groep" ? (_jsxs(Box, { sx: {
                        ...colCenter,
                        gap: isBelow390 ? 2 : isBelow1024 ? "34px" : "36px",
                    }, children: [_jsx(Box, { component: "img", src: linkVerification?.data?.user?.companyLogo ||
                                "/assets/images/company-logo.svg", sx: {
                                maxWidth: isSmallScreen ? 70 : 128,
                                maxHeight: isSmallScreen ? 50 : 74,
                                width: "auto",
                                height: "100%",
                                objectFit: "contain",
                                objectPosition: "center",
                            }, alt: "company Logo" }), _jsxs(Box, { sx: { ...colCenter, gap: 0.5, width: "100%" }, children: [_jsx(Typography, { fontSize: { xs: 10, md: 14 }, variant: "subtitle2", fontFamily: "PowerGrotesk", color: "#575756", children: t("header.partOf") }), _jsx("img", { src: "/assets/images/vdk-logo-top.svg", height: isSmallScreen ? 16 : 21, width: isSmallScreen ? 28 : 36, alt: "Logo" })] })] })) : (_jsx(Box, { component: "img", src: linkVerification?.data?.user?.companyLogo ||
                        "/assets/images/company-logo.svg", sx: {
                        height: "100%",
                        width: "auto",
                    }, alt: "company Logo" })), _jsxs(Box, { sx: { ...colCenter, gap: 2 }, children: [!isSmallScreen && _jsx(HeaderLinks, {}), _jsx(SwitchLanguage, {})] })] }) }));
};
export const HeaderLinks = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const searchParams = new URLSearchParams(location.search);
    const drawerParam = searchParams.get("drawer");
    const { t } = useTranslation();
    const theme = useTheme();
    const isSmallScreen = useMediaQuery("(max-width:900px)");
    const isBelow576 = useMediaQuery(theme.breakpoints.down(577));
    const isBelow450 = useMediaQuery(theme.breakpoints.down(451));
    const [isFaqOpen, setIsFaqOpen] = useState(false);
    const [isContactUsOpen, setIsContactUsOpen] = useState(false);
    const handleFAQOpen = () => {
        setIsFaqOpen(true);
        setIsContactUsOpen(false);
    };
    const handleContactUsOpen = () => {
        setIsContactUsOpen(true);
        setIsFaqOpen(false);
    };
    const menuItems = [
        {
            label: t("header.contactUs"),
            icon: _jsx(Message2, { size: 20 }),
            onClick: () => setIsContactUsOpen(true),
        },
        {
            label: t("header.faqs"),
            icon: _jsx(MessageQuestion, { size: 20 }),
            onClick: () => setIsFaqOpen(true),
        },
    ];
    useEffect(() => {
        if (drawerParam === "faq") {
            setIsFaqOpen(true);
            setIsContactUsOpen(false);
        }
        else if (drawerParam === "contact") {
            setIsContactUsOpen(true);
            setIsFaqOpen(false);
        }
    }, [drawerParam]);
    useEffect(() => {
        if (drawerParam) {
            navigate(location.pathname, { replace: true });
        }
    }, [isFaqOpen, isContactUsOpen]);
    return (_jsxs(_Fragment, { children: [_jsx(Box, { sx: {
                    display: "flex",
                    gap: 2,
                    mb: isSmallScreen ? 3 : 0,
                    alignItems: "center",
                    justifyContent: isSmallScreen ? "center" : "unset",
                }, children: menuItems.map((item, index) => {
                    return (_jsxs(_Fragment, { children: [isSmallScreen && index === 1 && (_jsx(Box, { sx: {
                                    background: "#FFFFFF",
                                    width: "1px",
                                    opacity: 0.2,
                                    height: "20px",
                                } })), _jsx(Button, { variant: "text", sx: {
                                    fontSize: "14px",
                                    borderRadius: 1,
                                    fontWeight: 500,
                                    color: isSmallScreen ? "white" : "#00244D",
                                    padding: isSmallScreen ? "4px 8px" : "",
                                    lineHeight: "1.2",
                                    minHeight: "auto",
                                    textTransform: "none",
                                    position: "relative",
                                    backgroundColor: "transparent",
                                    "&:hover": {
                                        backgroundColor: "transparent",
                                    },
                                    "&::after": {
                                        content: '""',
                                        position: "absolute",
                                        bottom: 0,
                                        left: 0,
                                        width: isSmallScreen ? "100%" : "0%",
                                        height: "1px",
                                        backgroundColor: isSmallScreen ? "white" : "#00244D",
                                        transition: "width 0.3s ease-in-out",
                                    },
                                }, color: "ePrimary", style: { background: "transparent !important" }, onClick: item.onClick, children: item.label }, index)] }));
                }) }), isFaqOpen && (_jsx(FAQs, { open: isFaqOpen, onContactUsOpen: handleContactUsOpen, onClose: () => setIsFaqOpen(false) })), isContactUsOpen && (_jsx(ContactUs, { onFAQOpen: handleFAQOpen, open: isContactUsOpen, onClose: () => setIsContactUsOpen(false) }))] }));
};
